var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "accessible-form-field", class: _vm.fieldClasses },
    [
      _vm.label
        ? _c(
            "label",
            {
              staticClass: "accessible-form-label",
              class: _vm.labelClasses,
              attrs: { for: _vm.fieldId },
            },
            [
              _vm._v("\n    " + _vm._s(_vm.label) + "\n    "),
              _vm.required
                ? _c(
                    "span",
                    {
                      staticClass: "required-indicator",
                      attrs: { "aria-label": "required field" },
                    },
                    [_vm._v("\n      *\n    ")]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.helpText
        ? _c(
            "div",
            {
              staticClass: "form-help-text",
              attrs: { id: _vm.fieldId + "-help", role: "note" },
            },
            [_vm._v("\n    " + _vm._s(_vm.helpText) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        _vm.fieldComponent,
        _vm._b(
          {
            tag: "component",
            class: _vm.inputClasses,
            attrs: {
              id: _vm.fieldId,
              "aria-required": _vm.required,
              "aria-invalid": _vm.hasError,
              "aria-describedby": _vm.describedByIds,
            },
            on: {
              blur: _vm.handleBlur,
              focus: _vm.handleFocus,
              input: _vm.handleInput,
              keydown: _vm.handleKeydown,
            },
            model: {
              value: _vm.internalValue,
              callback: function ($$v) {
                _vm.internalValue = $$v
              },
              expression: "internalValue",
            },
          },
          "component",
          _vm.inputAttributes,
          false
        ),
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.hasError
        ? _c(
            "div",
            {
              staticClass: "form-error-message",
              attrs: {
                id: _vm.fieldId + "-error",
                role: "alert",
                "aria-live": "assertive",
              },
            },
            [
              _c(
                "v-icon",
                {
                  staticClass: "error-icon",
                  attrs: { small: "", "aria-hidden": "true" },
                },
                [_vm._v("\n      fas fa-exclamation-triangle\n    ")]
              ),
              _vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  "),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasSuccess
        ? _c(
            "div",
            {
              staticClass: "form-success-message",
              attrs: {
                id: _vm.fieldId + "-success",
                role: "status",
                "aria-live": "polite",
              },
            },
            [
              _c(
                "v-icon",
                {
                  staticClass: "success-icon",
                  attrs: { small: "", "aria-hidden": "true" },
                },
                [_vm._v("\n      fas fa-check-circle\n    ")]
              ),
              _vm._v("\n    " + _vm._s(_vm.successMessage) + "\n  "),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showCharacterCount && _vm.maxLength
        ? _c(
            "div",
            {
              staticClass: "character-count",
              class: { "near-limit": _vm.characterCountNearLimit },
              attrs: { id: _vm.fieldId + "-count", "aria-live": "polite" },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.characterCount) +
                  "/" +
                  _vm._s(_vm.maxLength) +
                  " characters\n    "
              ),
              _c("span", { staticClass: "sr-only" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.characterCount === _vm.maxLength
                        ? "Character limit reached"
                        : ""
                    ) +
                    "\n    "
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }